export default __webpack_public_path__ + "static/media/neutral.1c31895d.png";